import { Suspense } from "react";
import {
  Await,
  LoaderFunction,
  NonIndexRouteObject,
  Outlet,
  useLoaderData,
} from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { LoadingSplash } from "@songtradr/design-language";
import { LoaderData, MFA_LAYOUT_ID, tempTokenCheck } from "./Mfa.Parts";

// LOADER
const MfaLoader: LoaderFunction = (): LoaderData => ({
  tempTokenCheck: tempTokenCheck(),
});

// WRAPPER
const MfaWrapper = () => {
  const { tempTokenCheck } = useLoaderData<LoaderData>();

  return (
    <Suspense fallback={<LoadingSplash />}>
      <Await resolve={tempTokenCheck} children={<Outlet />} />
    </Suspense>
  );
};

// LAYOUT
export const MfaLayout: NonIndexRouteObject = {
  id: MFA_LAYOUT_ID,
  errorElement: <GeneralErrorPage />,
  Component: MfaWrapper,
  loader: MfaLoader,
};
